import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
// import JwtService from "@/core/services/jwt.service";
// import axios from "axios";

// action types
export const UPDATE_DASHBOARD_DATA = "getFULFILLMENTTableData";

// mutation types
export const SET_DASHBOARD_DATA = "setFULFILLMENTTableData";

const state = {
  dashboard_data: [],
};

const getters = {
  getFULFILLMENTTableData(state) {
    return state.dashboard_data;
  },
};

const actions = {
  [UPDATE_DASHBOARD_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      // ApiService.post("login", credentials)
      ApiService.post("/dashboards/dashboardFulfillment", payload)
        .then(({ data }) => {
          // console.log("data of datatable ", data.charts);
          context.commit(SET_DASHBOARD_DATA, data?.charts);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_DASHBOARD_DATA](state, data) {
    state.dashboard_data = data;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
